export const PORTAL_ROOT_ID = "wlj-portal-root";

export const PORTAL_LAYERS = {
  toast: 1400,
  picker: 1350,
  modal: 1300,
  overlay: 1250,
};

export const getPortalRoot = () => {
  if (typeof document === "undefined") return null;

  let root = document.getElementById(PORTAL_ROOT_ID);
  if (!root) {
    root = document.createElement("div");
    root.id = PORTAL_ROOT_ID;
    root.setAttribute("aria-hidden", "true");
    document.body.appendChild(root);
  }

  return root;
};

// Toast + picker must sit on document.body (same stacking context as
// body-portaled modals). Nesting them under #wlj-portal-root (z 1200)
// keeps their 1400/1350 z-index trapped below modal 1300.
const BODY_ESCAPE_LAYERS = new Set(["toast", "picker"]);

export const getPortalLayerTarget = (layer = "modal") => {
  if (typeof document === "undefined") return null;

  const parent = BODY_ESCAPE_LAYERS.has(layer)
    ? document.body
    : getPortalRoot();
  if (!parent) return null;

  const layerId = `${PORTAL_ROOT_ID}-${layer}`;
  let target = document.getElementById(layerId);

  if (!target) {
    target = document.createElement("div");
    target.id = layerId;
    target.className = "wlj-portal-layer";
    target.dataset.portalLayer = layer;
    target.style.zIndex = String(PORTAL_LAYERS[layer] ?? PORTAL_LAYERS.modal);
    parent.appendChild(target);
  } else if (
    BODY_ESCAPE_LAYERS.has(layer) &&
    target.parentElement !== document.body
  ) {
    // Migrate layers created under the old nested portal root.
    document.body.appendChild(target);
  }

  if (BODY_ESCAPE_LAYERS.has(layer)) {
    // position + z-index so this layer paints above body-portaled modals (1300).
    target.style.position = "relative";
    target.style.zIndex = String(PORTAL_LAYERS[layer] ?? PORTAL_LAYERS.modal);
  }

  return target;
};
